import { MonthlyTask } from '@app/components/Calendars/components/MonthGrid/components/MonthlyTask/MonthlyTask.main';

export { MonthlyTask };
